import { render, staticRenderFns } from "./form-statictext.vue?vue&type=template&id=a1ec775c&"
import script from "./form-statictext.vue?vue&type=script&lang=js&"
export * from "./form-statictext.vue?vue&type=script&lang=js&"
import style0 from "./form-statictext.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports